var map = {
	"./Nuclear_Magnetic_Resonance.pdf": 9766,
	"./co487.pdf": 2040,
	"./cs135.pdf": 5075,
	"./cs240.pdf": 478,
	"./cs245.pdf": 3484,
	"./cs341.pdf": 1890,
	"./cs350.pdf": 3105,
	"./cs450.pdf": 2239,
	"./cs456.pdf": 7794,
	"./cs486.pdf": 6557,
	"./math239.pdf": 1090,
	"./resume.pdf": 7595,
	"./stat230.pdf": 4686,
	"./stat231.pdf": 4625
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2915;